(() => {
  const connection = navigator.connection;
  if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
  const link = document.createElement('link');
  if (!link.relList?.supports?.('prefetch')) return;
  link.rel = 'prefetch';
  document.head.appendChild(link);
  let timer, previous;
  function candidate(target) {
    const anchor = target instanceof Element ? target.closest('a[href]') : null;
    if (!anchor || anchor.hasAttribute('download') || anchor.dataset.noInstant !== undefined || anchor.target === '_blank') return;
    const url = new URL(anchor.href, location.href);
    if (url.origin !== location.origin || !['http:', 'https:'].includes(url.protocol) || url.search || url.hash) return;
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:products|collections|pages|blogs)(?:\/|$)/i.test(url.pathname)) return;
    if (url.pathname === location.pathname || url.href === previous) return;
    return url.href;
  }
  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'touch') return;
    clearTimeout(timer);
    const url = candidate(event.target);
    if (url) timer = setTimeout(() => {previous = url; link.href = url;}, 100);
  }, {passive: true});
  document.addEventListener('pointerout', () => clearTimeout(timer), {passive: true});
})();
